__webpack_require__.p = "/sharing-containers/referrals/";